<div class="lp-favorite-products-header">
  <div class="lp-favorite-products-header__wrapper">
    <button
      tuiIconButton
      type="button"
      iconStart="@tui.chevron-left"
      [appearance]="isDesktop ? 'secondary' : 'icon'"
      [size]="isDesktop ? 'l' : 'm'"
      [routerLink]="'/loyalty'"
    ></button>

    <div class="title">
      <h1>{{ title }}</h1>
    </div>
  </div>
</div>
